/**
 * Phase 43 D-23: the single-stage, role-based approval realm role.
 *
 * This is the ONLY TypeScript occurrence of the string literal assigned below. It is compared
 * case-sensitively by `hasRole` (AuthProvider) and by the backend's `RequireRole`/`IsInRole` —
 * pinned against the C# `ApprovingRole.Name` constant by
 * `Tests/Maja.Bff.Tests/Conventions/ApprovingRoleCouplingConventionTests.cs`. The DISPLAY LABEL
 * shown in the admin UI is free text and lives in `admin.json`'s
 * `users.keycloakRoles.labels.Approving` key — it is unrelated to this value and may differ per
 * locale.
 */
export const APPROVING_ROLE = 'Approving' as const;

/**
 * Phase 51 D-05: the cross-tenant operator realm role.
 *
 * This is the ONLY TypeScript occurrence of the string literal assigned below. It is compared
 * case-sensitively (`hasRole`, the admin tenant store) and by the backend's role checks — pinned
 * against the C# `PlatformAdminRole.Name` constant by plan 51-04's coupling test. Only a holder of
 * this role may work in a tenant other than its home tenant on `/admin` pages.
 */
export const PLATFORM_ADMIN_ROLE = 'platform_admin' as const;
